export type Controls = { stop: () => void };

/** Kept apart so tests can replace the camera; the decoder is loaded only when a scan starts. */
export async function startCameraDecoder(video: HTMLVideoElement, onText: (text: string) => void): Promise<Controls> {
  const { BrowserMultiFormatReader } = await import('@zxing/browser');
  const reader = new BrowserMultiFormatReader();
  return reader.decodeFromConstraints({ video: { facingMode: 'environment' } }, video, result => {
    if (result) onText(result.getText());
  });
}
